"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.airInput = exports.target = exports.inverter = exports.drive = exports.motor = exports.fanOperationalRange = exports.fanPerformancMmodel = exports.fanDefinition = exports.fanQuantity = exports.fanControlMode = void 0;
exports.fanControlMode = "fmptcontrolmode";
exports.fanQuantity = "fmptfanquantity";
exports.fanDefinition = "fmptfandefinition";
exports.fanPerformancMmodel = "fmptfanperformancemodel";
exports.fanOperationalRange = "fmptfanoperationalrange";
exports.motor = "fmptmotor";
exports.drive = "fmptdrive";
exports.inverter = "fmptinverter";
exports.target = "target";
exports.airInput = "airinput";
//# sourceMappingURL=group-names.js.map